import { createElement } from "react";
import classnames from "classnames";
import styles from "./training-plans-box.module.scss";
import Components from "@/components/components";
import { TrainingPlansBoxStoryblok } from "@/types/component-types-sb";

interface Props {
  blok: TrainingPlansBoxStoryblok;
}

const TrainingPlansBox = (props: Props) => {
  const {
    blok: { content },
  } = props;
  const classes = classnames(styles.wrapper);
  return content?.length ? (
    <div className={classes}>
      <div className={styles.content}>
        {content.map((blok) =>
          createElement(Components(blok.component), {
            key: blok._uid,
            blok: blok,
          })
        )}
      </div>
    </div>
  ) : null;
};

export default TrainingPlansBox;
